import React from "react";


function Footer() {

    return(

        <footer className="d-flex justify-content-center">
            <h1><a href="http://www.github.com/JoeBarbone" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github mx-2"></i></a></h1>
            <h1><a href="http://linkedin.com/in/joebarbone" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin mx-2"></i></a></h1>
            <h1><a href="http://twitter.com/joebarbone" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-twitter mx-2"></i></a></h1>
        </footer>

    )

}

export default Footer;